var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTreatmentPlanShortcutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1182_2867)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 20C8.8 19.9 7.6 19.5 6.4 19C5.2 18.5 4.1 17.8 3.2 16.8C2.3 15.8 1.5 14.6 0.9 13.2C0.3 11.8 0 10 0 8V7H1C1.9 7 2.7 7.1 3.6 7.3C4.5 7.5 5.3 7.8 6.1 8.3C6.3 6.9 6.8 5.4 7.5 3.9C8.2 2.4 9.1 1.1 10 0C10.9 1.1 11.8 2.4 12.5 3.9C13.2 5.4 13.7 6.9 13.9 8.3C14.7 7.9 15.5 7.5 16.4 7.3C17.3 7.1 18.1 7 19 7H20V8C20 10 19.7 11.8 19.1 13.2C18.5 14.6 17.8 15.8 16.8 16.8C15.9 17.7 14.8 18.5 13.6 19C12.4 19.5 11.2 19.9 10 20Z",
    fill: "#5d3cc7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.9 18C9.7 15.2 8.9 13.1 7.4 11.7C5.9 10.3 4.2 9.39998 2 9.09998C2.2 11.9 3 14.1 4.5 15.5C6 16.9 7.9 17.7 9.9 18Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 11.6C10.2 11.2 10.6 10.9 10.9 10.5C11.3 10.1 11.6 9.8 11.9 9.5C11.9 8.6 11.7 7.6 11.3 6.5C11 5.5 10.5 4.5 9.90002 3.5C9.30002 4.5 8.90002 5.5 8.50002 6.5C8.10002 7.5 8.00002 8.5 7.90002 9.5C8.20002 9.8 8.60002 10.1 9.00002 10.5C9.50002 10.9 9.80002 11.2 10 11.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9 17.5C12.5 17.3 13.2 17 13.8 16.6C14.4 16.2 15.1 15.7 15.7 15C16.3 14.3 16.8 13.5 17.2 12.5C17.6 11.5 17.9 10.3 17.9 8.90002C16.3 9.10002 15 9.70002 13.8 10.5C12.6 11.3 11.7 12.3 11.1 13.6C11.3 14.1 11.5 14.7 11.6 15.4C11.7 16.1 11.9 16.8 11.9 17.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1182_2867"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreatmentPlanShortcutIcon);
export default __webpack_public_path__ + "static/media/treatment_plan_shortcut_icon.3ab01ef64ae9aa9dc7e83ccf4b2bb309.svg";
export { ForwardRef as ReactComponent };